// extracted by mini-css-extract-plugin
export default {"tag":"eventslot_tag__kgN1I"};